// extracted by mini-css-extract-plugin
module.exports = {"activeItem":"ActiveItem_activeItem__agRBG","questions":"ActiveItem_questions__zjATs"};